import React, {Component} from 'react';
import Grid from 'react-bootstrap/lib/Grid';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import constants from '../../config/constants';




class ThankYou extends Component {
 
   state = {"message" :'Thank you for registering '+constants.tournament+"!",
            "redirectToPayment": false};

  componentDidMount(){
    let url = window.location.href;
    let id = '';
    if(url){
      let urlTemp = url.split("?");
      // console.log(urlTemp);
      if(urlTemp[1]){
        // console.log(urlTemp[1]);
        let param = urlTemp[1].split("=");
        // console.log(param);
        if(param[1]){
          // console.log(param[1]);
          id = param[1];
        }
      }
    }

    // console.log('id : ',id);

    let playerobj={"payload":{"Item":{"sessionId": id}}};          
    // console.log(playerobj);   
    if(this.state.redirectToPayment){ 
        fetch('https://3qwgurow1h.execute-api.us-east-1.amazonaws.com/pramukhcup/player', {
          method: 'post',
          headers: {'Content-Type':'application/json'},
          body: JSON.stringify(playerobj)
        }).then(results => {            
          return results.json();
        }).then(resp => {
          // console.log('resp : '+resp.message);
          this.setState({message:resp.message});
          setTimeout(function() {
            this.setState({displayModel:false});
            this.props.history.push('/players'); }.bind(this), 3000);
          
        }).catch( error => {
                    // console.log(error);
                    this.setState({message:'Please contact your zone lead and provide ID : '+id});
                  } );
    } else {
      setTimeout(function() {
        this.props.history.push('/players'); }.bind(this), 3000);
    }

  }


render(){

    return (
      <div className="container-fluid">
          <div className="card">
              <Grid>
                <Row>
                  <Col xs={3} md={3}></Col>
                  <Col xs={5} md={4}>
                    <p class="ThankYou">{this.state.message}</p>
                  </Col>
                  <Col xs={4} md={4}></Col>
                </Row>
              </Grid>             
          </div>
      </div>
    );

}

}

export default ThankYou;



// WEBPACK FOOTER //
// ./src/pages/ThankYou/index.js